import { Box, Button, Dialog, DialogActions, DialogContent, type Theme, Typography } from "@mui/material";
import { InAppHelpCenterTrackingSource, openArticleInHelpCenter } from "../../nooks/helpCenter";
import {
    getPermissionDeniedModalDescription,
    getPermissionDeniedModalTitle
} from "./recordingToolDialogConfig";
import type { SxProps } from "@mui/system";
import React from "react";
import { TruffleDialogTitle } from "@sundaysky/smartvideo-hub-truffle-component-library";
import type { RecordingToolPermissionDeniedType } from "../../hooks/RecordingTool/UseRecordingToolPermissionDenied";

const recordingGif = require("../../../../images/recording-turn-on-permission.gif");

type PermissionDeniedModalProps = {
    permissionDenied: RecordingToolPermissionDeniedType;
    onClose: () => void;
}

export const PermissionDeniedModal = ({ permissionDenied, onClose } : PermissionDeniedModalProps) => {

    return (
        <Dialog
            open={true}
            onClose={onClose}
            fullWidth
            PaperProps={{ sx: { width: "446px" } }}
        >
            <TruffleDialogTitle
                CloseIconButtonProps={{ onClick: onClose }}
                HelpCenterIconButtonProps={{
                    onClick: (event) => {
                        void openArticleInHelpCenter({
                            buttonId: "7473e39a-315c-4442-a2c2-a85c1fb866a9",
                            anchorRef: event.currentTarget,
                            trackingSource: InAppHelpCenterTrackingSource.Editor,
                            trackingDialogName: "tracking-id-recorder-permissions-error-dialog"
                        });
                    }
                }}
            />
            <DialogContent sx={DialogContentSxProps}>
                <Box
                    component={"img"}
                    src={recordingGif}
                    aria-label={"recording-turn-on-permission"}
                    sx={{ width: "380px" }}
                />
                <Typography variant={"h5"}>{getPermissionDeniedModalTitle[permissionDenied]}</Typography>
                <Typography align={"center"} sx={{ whiteSpace: "pre-line" }} variant={"body1"}>
                    {getPermissionDeniedModalDescription[permissionDenied]}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ margin: "auto", marginBottom: "16px" }}>
                <Button
                    variant="contained"
                    onClick={onClose}
                >
                    {"Got it"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};



const DialogContentSxProps: SxProps<Theme> = {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "center",
    justifyContent: "center"
};
